import { Office, ResourceType, UserRoles } from '@gettactic/api';
import { getMaxDateAllowedToReserve } from './getMaxDateAllowedToReserve';
import { getMinDateAllowedToReserve } from './getMinDateAllowedToReserve';

export function isAllowedToReserve(
  day: Date,
  officeTimezone: string,
  office: Office | undefined,
  resType: ResourceType,
  roles: UserRoles[] = []
) {
  const max = getMaxDateAllowedToReserve(officeTimezone, office, resType);
  const min = getMinDateAllowedToReserve(officeTimezone);
  if (!roles.includes('owner') && day.getTime() < min.getTime()) {
    return false;
  }
  if (max && day.getTime() > max.getTime()) {
    return false;
  }
  return true;
}
